import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Import your JSON translation files
const resources = {
  en: { translation: require("./en-US.json") },
  "en-US": { translation: require("./en-US.json") },
  de: { translation: require("./de-DE.json") },
  "de-DE": { translation: require("./de-DE.json") },
  es: { translation: require("./es-ES.json") },
  "es-ES": { translation: require("./es-ES.json") },
  fr: { translation: require("./fr-FR.json") },
  "fr-FR": { translation: require("./fr-FR.json") },
  hi: { translation: require("./hi-IN.json") },
  "hi-IN": { translation: require("./hi-IN.json") },
  it: { translation: require("./it-IT.json") },
  "it-IT": { translation: require("./it-IT.json") },
  ja: { translation: require("./ja-JP.json") },
  "ja-JP": { translation: require("./ja-JP.json") },
  ko: { translation: require("./ko-KR.json") },
  "ko-KR": { translation: require("./ko-KR.json") },
  pt: { translation: require("./pt-PT.json") },
  "pt-PT": { translation: require("./pt-PT.json") },
  ru: { translation: require("./ru-RU.json") },
  "ru-RU": { translation: require("./ru-RU.json") },
  uk: { translation: require("./uk-UA.json") },
  "uk-UA": { translation: require("./uk-UA.json") },
  zh: { translation: require("./zh-CN.json") },
  "zh-CN": { translation: require("./zh-CN.json") },
  "zh-HK": { translation: require("./zh-HK.json") },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    debug: process.env.NODE_ENV === "development",
    resources,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"],
    },
    supportedLngs: Object.keys(resources),
  });

export default i18n;
